export default "__VITE_ASSET__0rkU_47r__"